import React from "react";
import {
	Button,
	ClassNameProps,
	Column,
	doNothing,
	Heading,
	makeClassName,
	Modal,
	ModalProps,
	Paragraph,
	Row,
	Section,
	StyleProps,
} from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import styles from "./styles.module.css";

export type PaymentGuideModalControllerProps = Partial<ClassNameProps & StyleProps>;

export function PaymentGuideModalController({ className, style }: PaymentGuideModalControllerProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button
				variant="tertiary"
				onClick={openModal}
				className={makeClassName(styles["button"], className)}
				style={style}
			>
				<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
					<Icon.Question size={20} /> How to Pay Guide
				</Row>
			</Button>

			<Modal.If condition={isModalOpen}>
				<PaymentGuideModal onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}

export type PaymentGuideModalProps = Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function PaymentGuideModal({ ifRef, onClose, className, style }: PaymentGuideModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>How to Pay Guide</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<Column justify="spaced-start">
					<Section>
						<Section.Header>
							<Heading.H3 noMargin>By Check</Heading.H3>
						</Section.Header>
						<Section.Body>
							<Column justify="spaced-start">
								<Paragraph>
									To pay by check, please either send the check in the mail to the address listed below:
								</Paragraph>

								<Row
									justify="center"
									style={{
										backgroundColor: "var(--neutral-colors--light)",
										padding: "1.25rem 1rem",
										borderRadius: "0.75rem",
									}}
								>
									<Column justify="spaced-start" verticalSpacing="0.25rem">
										<strong>Verita International School</strong>
										<strong>Soldat Gheorghe Pripu Street 22A</strong>
										<strong>1st District, Bucharest 077190, Romania</strong>
									</Column>
								</Row>

								<Paragraph>You may also bring the check directly to our office.</Paragraph>
							</Column>
						</Section.Body>
					</Section>

					<Section>
						<Section.Header>
							<Heading.H3 noMargin>By Bank Transfer</Heading.H3>
						</Section.Header>
						<Section.Body>
							<Column justify="spaced-start">
								<Paragraph>
									To pay with a bank transfer, please send transfer to the following account details:
								</Paragraph>

								<Row
									justify="center"
									style={{
										backgroundColor: "var(--neutral-colors--light)",
										padding: "1.25rem 1rem",
										borderRadius: "0.75rem",
									}}
								>
									<Column justify="spaced-start" verticalSpacing="0.25rem">
										<strong>Verita International School</strong>
										<strong>Swift: BTRLRO22XXX</strong>
										<strong>Bank: Banca Transilvania</strong>
									</Column>
								</Row>
							</Column>
						</Section.Body>
					</Section>

					<Section>
						<Section.Header>
							<Heading.H3 noMargin>By Cash</Heading.H3>
						</Section.Header>
						<Section.Body>
							<Column justify="spaced-start">
								<Paragraph>To pay with cash, please bring the payment to our office located at:</Paragraph>

								<Row
									justify="center"
									style={{
										backgroundColor: "var(--neutral-colors--light)",
										padding: "1.25rem 1rem",
										borderRadius: "0.75rem",
									}}
								>
									<Column justify="spaced-start" verticalSpacing="0.25rem">
										<strong>Verita International School</strong>
										<strong>Soldat Gheorghe Pripu Street 22A</strong>
										<strong>1st District, Bucharest 077190, Romania</strong>
									</Column>
								</Row>
							</Column>
						</Section.Body>
					</Section>

					<Section>
						<Section.Header>
							<Heading.H3 noMargin>Questions &amp; Assistance</Heading.H3>
						</Section.Header>
						<Section.Body>
							<Column justify="spaced-start">
								<Paragraph>
									For questions about and assistance with making a payment please contact a member of our finance team
									by clicking the button below:
								</Paragraph>

								<Row justify="center">
									<Button variant="primary" onClick={doNothing}>
										Send Message in Portal
									</Button>
								</Row>

								<Paragraph>For assistance over the phone, please use the number displayed below:</Paragraph>

								<Row
									justify="center"
									style={{
										backgroundColor: "var(--neutral-colors--light)",
										padding: "1.25rem 1rem",
										borderRadius: "0.75rem",
									}}
								>
									<Column justify="spaced-start" verticalSpacing="0.25rem">
										<strong>+4 0728 049 449</strong>
									</Column>
								</Row>
							</Column>
						</Section.Body>
					</Section>
				</Column>
			</Modal.Body>
		</Modal>
	);
}
